import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useIsInitialized } from '@s-group/react-usercentrics'

import Header from "./header"
import Footer from "./footer"
import { useTranslation } from 'react-i18next';
import ScrollTop from "./_scrollTop.jsx"
import ScrollToHashElement from "./_ScrollToHashElement";

import { Helmet } from 'react-helmet';
import seo_data from '../file/seo.json';
import { UserContext } from "./context/UserContext";

const Layout = () => {

  const { t, i18n } = useTranslation();

  const [pageName, setPageName] = useState("")
  const { pathname, hash } = useLocation();

  const [seoState, setSeoState] = useState({
    "title": "",
    "description": "",
    "keywords": ""
  })

  const { login, logout, user } = useContext(UserContext)

  const isInitialized = useIsInitialized()

  /**
   * Set page name from the windows path
   */
  useEffect(() => {

    //set page name for wrapper
    const currentPageName = pathname.replace('/', '').split("/").join("_")
    setPageName(currentPageName === "" ? 'index' : currentPageName)

    window.scrollTo(0, 0)

    //seo stuff
    const seo = seo_data[currentPageName] !== undefined ? seo_data[currentPageName] : seo_data["default"]

    setSeoState({
      title: seo.title,
      description: seo.description,
      keywords: seo.keyword
    })

  }, [pathname, hash])

  /**
   * handle mixpanel init
   */
  useEffect(() => {

    /*if(window.mixpanelhandler !== undefined)
      return

    if (window.mixpanel === undefined)
      return*/

    //init mixpanel
    if (process.env.REACT_APP_MIXPANEL_TOKEN !== "" && window.mixpanel !== undefined) {

      //mixpanel actif
      console.log("mixpanel init");

      window.mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { api_host: process.env.REACT_APP_MIXPANEL_PROXY });
      window.mixpanel.register({
        "Country": "France",
        "Job ID": process.env.REACT_APP_MIXPANEL_JOBID
      });

    }

    //mixpanel handler
    window.mixpanelhandler = {
      track: function (event, param) {

        //console.log(window.mixpanel,process.env.REACT_APP_MIXPANEL_TOKEN)

        if (window.mixpanel !== undefined && process.env.REACT_APP_MIXPANEL_TOKEN != "") {
          window.mixpanel.track(event, param);

          if (process.env.REACT_APP_MIXPANEL_DEBUG && process.env.REACT_APP_MIXPANEL_DEBUG === "TRUE")
            console.log("track ->", event, param);

        }
        else if (process.env.REACT_APP_MIXPANEL_DEBUG && process.env.REACT_APP_MIXPANEL_DEBUG === "TRUE") {
          //mixpanel inactif
          console.log("mixpanel pas dispo");
          console.log("track", event, param);
        }

        return true;
      }
    }

  }, [window.mixpanel])
  /**
   * handle mixpanel event
   */
  useEffect(() => {

    if (!isInitialized || window.mixpanelhandler === undefined)
      return;

    switch (pageName) {
      case "index": window.mixpanelhandler.track("Homepage_Loaded", { "Result count": 1 }); break;
      case "inscription": window.mixpanelhandler.track("Participation_Form viewed", { "Result count": 1 }); break;
      case "mon-compte": window.mixpanelhandler.track("Account page_Loaded", { "Result count": 1 }); break;
      case "mes-cartes": window.mixpanelhandler.track("Game Path_Loaded", { "Result count": 1 }); break;
      case "prochainement": window.mixpanelhandler.track("Next activation page_Loaded", { "Result count": 1 }); break;
      case "les-cadeaux": window.mixpanelhandler.track("Gift page_Viewed", { "Result count": 1 }); break;
    }

  }, [isInitialized, pageName, window.mixpanel])


  /*
  UPDATE USERCENTRICS STYLE
   */
  useEffect(() => {

    if (!document.getElementById("usercentrics-root"))
      return

    var style = document.createElement('style')
    style.innerHTML = '#uc-center-container{ align-self: flex-start; border-radius: 0; }'
    document.getElementById("usercentrics-root").shadowRoot.appendChild(style)
  }, [document.getElementById("usercentrics-root")])

  return (
    <>
      <div className={`lang-${i18n.language} page_wrapper ${user.connected ? "" : "logout"}`} id={"page_" + pageName + "_wrapper"}>
        <Helmet>
          <title>{seoState.title}</title>
          <meta name="description" content={seoState.description} />
          <meta name="keyword" content={seoState.keywords} />
        </Helmet>

        <Header />

        <div className="content_wrapper" id={"content_" + pageName + "_wrapper"}>
          <Outlet />
        </div>

        <Footer />

        <ScrollTop />
        <ScrollToHashElement />
      </div>
    </>
  );
}

export default Layout;
